import React, { useState, useEffect, useRef, useMemo } from "react";
import styled from "styled-components";
import styles from "styles/genai/Edetail.module.scss";
import { Tooltip, withStyles } from "@material-ui/core";
import bulbIcon from "img/genai/bulb.svg";
import bluIcon from "img/loadingblue.svg";
import ModuleStepper from "./ModuleStepper";
import { useKeycloak } from "@react-keycloak/web";
import CustomTextField from "../../../components/CustomTextField";
import DropDownWithSearch from "../../../components/DropDownWithSearch";
import moduleimage from "img/genai/modulepic.svg";
import MultiSelectDropDownWithInlineSearch from "../../../components/MultiSelectDropDownWithInlineSearch";
import { CustomAccordion } from "../utils/CustomAccordian";
import {
  getLanguageForCountry,
  getSubTopics,
  getSegmentList,
  getDraftElementsList,
  getStrategicObjectivesForBrand,
  getAgencyList,
  fetchMarkets,
  fetchBrands,
  fetchTopicsAndSubtopics,
  getAudienceList,
  getTherapeuticAreaList,
  getIndicationsListFromApi,
  getContentToneList,
} from "services/apis";
import {
  showError,
  getIndicationData,
  getLanguageData,
  getAudienceData,
  getTheurapiticData,
  getSegmentData as formatSegmentData,
  getStrategiData,
  getDraftElementsIncludedData,
  getAgencyData,
  getContentToneData,
} from "Uitls/Util";
import CircularProgressBar from "Uitls/CircularProgressBar";
import ModulePreviewData from "components/modules/ModulePreviewData";
import { Spinner } from "react-bootstrap";
import { LoaderEdt } from "../utils/LoaderEdt";
import { getSummaryInfo } from "../api/genapi";
import { GenaiLoader } from "../utils/GenaiLoader";
import CustomModal from "components/customModal";
import ConfirmationPopup from "components/ConfirmationPopup";
import { PreviewToggle } from "./slides/PreviewToggle";
import { ShowSlideImg, ShowSlideImgNew } from "./slides/ShowSlideImg";
import { SlideTabsControl } from "./slides/SlideTabs";

// Add a container styling for CustomTextField
const CustomTextFieldContainer = styled.div`
  .textfield-container {
    margin-bottom: 0 !important;
    height: 10%;
  }

  /* Match the styling of other form elements */
  .MuiFilledInput-root {
    background-color: white !important;
    border: 1px solid #d1d1d6 !important;
    border-radius: 4px !important;
  }

  /* Handle error state by leveraging the focused class */
  &.error .MuiFilledInput-root {
    border-color: #ff3b30 !important;
  }

  /* Specific styles for the multiline variant */
  &.multiline .MuiFilledInput-root {
    height: 10%;
    // min-height: 100px;
  }

  /* Ensure character counter has right spacing */
  .char-count {
    margin-top: 4px;
    text-align: right;
  }
`;

// Custom styling for DropDownWithSearch
const DropdownContainer = styled.div`
  /* Apply error styling */
  &.error .MuiFilledInput-root {
    border-color: #ff3b30 !important;
  }

  /* Adjust margins */
  .MuiAutocomplete-root {
    margin-bottom: 0 !important;
  }
`;

export const ModuleElementModal = ({
  isOpen,
  onClose,
  currentModule,
  totalModules,
  onBack,
  onCancel,
  onNext,
  onGenerateCMSD,
  moduleMetadata = {},
  elements = [],
  onMetadataChange,
  metaDataDropDownList = {},
  buttonLoading,
  elementsLoading,
  onUsageTypeChange,
  onElementDeselect,
  assetId,
  pageId,
  countryNameUI,
  moduleId,
  userCollectedMeta,
  multiModuleCreation = false,
  multipleModulesData = [],
  selectedModules = [],
  createdModules = [],
  onModuleSelectionChange,
  onModuleNavigate,
  showAllPreview,
  showMissingMetadataPopup,
  setShowMissingMetadataPopup,
  missingMetadataModules,
}) => {
  const loadedModulesRef = useRef(new Set());
  const [isLoading, setIsLoading] = useState(false);
  const [showTooltip, setShowTooltip] = React.useState(false);
  const tooltipContentRef = React.useRef(null);
  const bulbIconRef = React.useRef(null);
  const [rationalData, setRationalData] = useState("");
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const { isPreviewOpen, setIsPreviewOpen } = showAllPreview;

  // const moduleExists =
  //   !!moduleId &&
  //   createdModules[currentModule - 1] &&
  //   selectedModules[currentModule - 1];
  const moduleExists = false;
  const [activeSlideId, setActiveSlideId] = useState(null);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [rationaleCache, setRationaleCache] = useState({});
  const [isRationaleLoading, setIsRationaleLoading] = useState(false);

  // Add this useEffect to preserve scroll position
  useEffect(() => {
    // Get the rightMEM element
    const rightMemElement = document.querySelector(`.${styles.rightMEMNew}`);

    if (rightMemElement) {
      // Save current scroll position
      const scrollTop = rightMemElement.scrollTop;

      // Restore it after module change (tiny delay)
      setTimeout(() => {
        if (rightMemElement) {
          rightMemElement.scrollTop = scrollTop;
        }
      }, 10);
    }
  }, [currentModule]); // Runs when module changes

  const handleCheckboxChange = (moduleIndex, isChecked) => {
    if (onModuleSelectionChange) {
      onModuleSelectionChange(moduleIndex, isChecked);

      // AUTO-NAVIGATE WHEN CHECKING
      if (isChecked && onModuleNavigate) {
        onModuleNavigate(moduleIndex + 1);
      }
    }
  };

  // Handler for module navigation
  const handleModuleClick = (moduleIndex) => {
    if (selectedModules[moduleIndex]) {
      onModuleNavigate(moduleIndex + 1);
    }
  };

  const getModuleDisplayName = (index) => {
    if (multiModuleCreation && multipleModulesData[index]) {
      return multipleModulesData[index].moduleNumber || `Module_${index + 1}`;
    } else {
      // Force "Module_X" for normal flow
      return `Module_${index + 1}`;
    }
  };

  const canModuleBeUnchecked = (index) => {
    // Allow unchecking even if created - will trigger deletion
    return true; // Always allow unchecking
  };
  // Add this useEffect for controlled initialization
  useEffect(() => {
    if (isOpen && !isInitialized) {
      initializeData();
      setIsInitialized(true);
    } else if (!isOpen && isInitialized) {
      // Reset initialization state when modal closes

      setIsInitialized(false);
      loadedModulesRef.current.clear();
    }
  }, [isOpen, isInitialized, currentModule]);

  // Add the initializeData function
  const initializeData = async () => {
    try {
      await Promise.all([
        getAgency(),
        getTherapeuticAreaData(),
        getAudienceData(),
        getIndicationData(),
        getCountryData(),
        getProductData(),
        getTopicData(),
      ]);
    } catch (error) {
      console.error("Error initializing data:", error);
    }
  };

  const loadRationalData = () => {
    setIsRationaleLoading(true); // Start loading

    if (multiModuleCreation && multipleModulesData.length > 0) {
      // Multi-module flow
      const moduleRationale =
        multipleModulesData[currentModule - 1]?.moduleRationale;
      setRationalData(
        moduleRationale || "No rationale available for this module",
      );
      setIsRationaleLoading(false);
    } else if (userCollectedMeta?.length > 0) {
      // API flow with caching
      const cacheKey = `page-${pageId}-module-${currentModule}`;

      if (rationaleCache[cacheKey]) {
        // Cache hit
        setRationalData(rationaleCache[cacheKey]);
        setIsRationaleLoading(false);
        return;
      }

      // Cache miss - show loading
      const objective =
        userCollectedMeta[userCollectedMeta.length - 1]?.objective;
      const topic = userCollectedMeta[userCollectedMeta.length - 1]?.topic;

      if (assetId?.assetId) {
        setIsApiLoading(true);
        getSummaryInfo(
          assetId?.assetId,
          pageId,
          countryNameUI,
          objective,
          topic,
          (res, err) => {
            setIsApiLoading(false);
            setIsRationaleLoading(false);

            if (res) {
              const rationaleText = res.summary || "No rationale available";

              // Store in cache
              setRationaleCache((prev) => ({
                ...prev,
                [cacheKey]: rationaleText,
              }));

              setRationalData(rationaleText);
            } else {
              console.log(err);
              setRationalData("Unable to fetch rationale");
            }
          },
        );
      } else {
        setRationalData("No asset information available");
        setIsRationaleLoading(false);
      }
    } else {
      setRationalData("No user collected metadata available");
      setIsRationaleLoading(false);
    }
  };

  // In ModuleElementModal component:
  useEffect(() => {
    if (isOpen && currentModule) {
      loadRationalData();
    }
  }, [
    isOpen,
    currentModule,
    multiModuleCreation,
    multipleModulesData,
    userCollectedMeta,
    pageId, // Make sure this is in dependencies
    assetId?.assetId, // Add this too
    countryNameUI, // Add this since it's used in API call
  ]);

  useEffect(() => {
    if (isOpen) {
      // Check if we haven't loaded data for this specific module yet
      if (!loadedModulesRef.current.has(currentModule)) {
        loadedModulesRef.current.add(currentModule);

        // Load ALL basic data for this module
        const loadData = async () => {
          try {
            await Promise.all([
              getAgency(),
              getTherapeuticAreaData(),
              getAudienceData(),
              getIndicationData(),
              getCountryData(),
              getProductData(),
              getTopicData(),
            ]);
          } catch (error) {
            console.error(" Error loading data:", error);
          }
        };

        loadData();
      } else {
        // console.log(`Module ${currentModule} data already loaded`);
      }
    }

    // Reset when modal closes
    if (!isOpen) {
      loadedModulesRef.current.clear();
    }
  }, [isOpen, currentModule]);

  //  DEPENDENT DROPDOWN useEffect (you already have this)
  useEffect(() => {
    if (isOpen) {
      // Language depends on country
      if (moduleMetadata?.country?.veevaId && !languageForCountry.length) {
        getLanguagesForSelectedCountry();
      }

      // Segments depend on product + country
      if (
        moduleMetadata?.product?.veevaId &&
        moduleMetadata?.country?.veevaId &&
        !segmentList.length
      ) {
        getSegmentDataList(
          moduleMetadata.product.veevaId,
          moduleMetadata.country.veevaId,
        );
      }

      // Subtopics depend on product + topic
      if (moduleMetadata?.product?.veevaId && moduleMetadata?.topic?.veevaId) {
        getSubTopicsData(
          moduleMetadata.product.veevaId,
          moduleMetadata.topic.veevaId,
        );
      }

      // Strategic objectives depend on product
      if (moduleMetadata?.product?.veevaId && !strategicObjList.length) {
        getStrategicObjectivesList();
      }

      // Content tone depends on product
      if (moduleMetadata?.product?.veevaId && !contentToneList.length) {
        getContentTone();
      }

      // Draft elements depend on US country
      if (
        moduleMetadata?.country?.veevaId === "unitedStates" &&
        !draftElementsList.length
      ) {
        getDraftElementsData();
      }
    }
  }, [isOpen, moduleMetadata?.topic?.veevaId]);
  useEffect(() => {
    if (assetId && assetId.slideIds.length > 0) {
      setActiveSlideId(assetId.slideIds[0]);
    }
  }, [assetId]);

  useEffect(() => {
    if (assetId && activeSlideId) {
      const index = assetId.slideIds.findIndex((id) => id === activeSlideId);
      if (index >= 0) {
        setCurrentSlideIndex(index);
      }
    }
  }, [activeSlideId, assetId]);
  // Handle click outside to close tooltip
  useEffect(() => {
    if (showTooltip) {
      const handleClickOutside = (event) => {
        if (
          tooltipContentRef.current &&
          !tooltipContentRef.current.contains(event.target) &&
          bulbIconRef.current &&
          !bulbIconRef.current.contains(event.target)
        ) {
          setShowTooltip(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [showTooltip]);

  const [showCancelModal, setShowCancelModal] = useState(false);
  const { keycloak } = useKeycloak();
  const userName = !!keycloak.authenticated ? keycloak.tokenParsed.name : null;

  // API response data
  const [subTopics, setSubTopics] = useState([]);
  const [agencyList, setAgencyList] = useState([]);
  const [segmentList, setSegmentList] = useState([]);
  const [audienceList, setAudienceList] = useState([]);
  const [indicationList, setIndicationList] = useState([]);
  const [strategicObjList, setStrategicObjList] = useState([]);
  const [draftElementsList, setDraftElementsList] = useState([]);
  const [languageForCountry, setLanguageForCountry] = useState([]);
  const [therapeuticAreaList, setTherapeuticAreaList] = useState([]);
  const [contentToneList, setContentToneList] = useState([]);
  // Add a useEffect to show errors when user attempts to proceed with invalid data
  const [showValidationErrors, setShowValidationErrors] = useState(false);

  // Add state variables to hold the dropdown options
  const [topicOptions, setTopicOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);

  // Add this near the other state variables
  const [elementUsageTypes, setElementUsageTypes] = useState({});
  const [matchSegmentItems, setMatchSegmentItems] = useState([]);

  const userMeta = userCollectedMeta?.[userCollectedMeta.length - 1] || {};
  const findMatchingOption = (userMetaValue, options) => {
    if (!userMetaValue || !options) return null;

    return options.find(
      (option) =>
        option.displayName === userMetaValue ||
        option.id === userMetaValue ||
        option.veevaId === userMetaValue,
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setMatchSegmentItems(renderDropdownOptions(segmentList));
    }, 1700);

    return () => clearTimeout(timer);
  }, [segmentList]);

  useEffect(() => {
    const initializeTopic = () => {
      // Direct check for the empty topic object structure
      if (
        moduleMetadata?.topic?.id === "" &&
        moduleMetadata?.topic?.displayName === "" &&
        moduleMetadata?.topic?.veevaId === "" &&
        userMeta?.topic &&
        topicOptions.length > 0
      ) {
        const matchedTopic = findMatchingOption(userMeta.topic, topicOptions);
        if (matchedTopic) {
          handleDropdownSelection(matchedTopic, "topic");
        }
      }
    };

    initializeTopic();
  }, [userMeta?.topic, topicOptions.length, moduleMetadata?.topic]);

  // Add utility functions to transform API data for dropdowns

  const attemptProceed = () => {
    // Check if there are any elements available
    const hasNoElements =
      (!elements?.claims || elements.claims.length === 0) &&
      (!elements?.reusableTexts || elements.reusableTexts.length === 0) &&
      (!elements?.components || elements.components.length === 0);

    // If there are no elements, proceed without validation
    if (hasNoElements) {
      if (showGenerateButton) {
        onGenerateCMSD(); // This will check ALL selected modules
      } else {
        onNext();
      }
      return;
    }

    const hasAvailableClaims = elements?.claims && elements.claims.length > 0;
    const hasAvailableRTs =
      elements?.reusableTexts && elements.reusableTexts.length > 0;

    const hasSelectedClaims =
      moduleMetadata?.selectedElements?.claims?.length > 0;
    const hasSelectedRTexts =
      moduleMetadata?.selectedElements?.reusableTexts?.length > 0;

    // Require at least ONE claim OR ONE reusable text
    const hasValidSelection = hasSelectedClaims || hasSelectedRTexts;

    // Check if validation fails (elements available but none selected)
    if ((hasAvailableClaims || hasAvailableRTs) && !hasValidSelection) {
      setShowValidationErrors(true);

      const contentElement = document.querySelector('[class^="ModuleContent"]');
      if (contentElement) {
        contentElement.scrollTop = 0;
      }
      return;
    }

    if (!isNextEnabled) {
      // If validation fails, show validation errors
      setShowValidationErrors(true);
      // Scroll to the top to show errors
      const contentElement = document.querySelector('[class^="ModuleContent"]');
      if (contentElement) {
        contentElement.scrollTop = 0;
      }
    } else {
      // If validation passes, proceed
      if (showGenerateButton) {
        // CURRENT MODULE IS VALID - Now parent will check ALL selected modules
        onGenerateCMSD();
      } else {
        onNext();
      }
    }
  };

  const transformCountryData = (data) => {
    if (!data || !Array.isArray(data)) return [];
    return data.map((item, index) => ({
      id: item?.id,
      displayName: item.countryName || item.name,
      veevaId: item.countryDamId || item.id,
    }));
  };

  const transformProductData = (data) => {
    if (!data || !Array.isArray(data)) return [];
    return data.map((item, index) => ({
      id: item.productDamId,
      displayName: item.productName,
      veevaId: item.productDamId || item.id,
    }));
  };

  const transformTopicData = (data) => {
    if (!data || !Array.isArray(data)) return [];
    return data.map((item, index) => ({
      id: item.topicDamId,
      displayName: item.topicName,
      veevaId: item.topicDamId || item.id,
    }));
  };

  const transformSubTopicData = (data) => {
    if (!data || !Array.isArray(data)) return [];
    return data.map((item, index) => ({
      id: item.subtopicDamId,
      displayName: item.subtopicName,
      veevaId: item.subtopicDamId || item.id,
    }));
  };

  const transformIndicationData = (data) => {
    if (!data || !Array.isArray(data)) return [];
    return data.map((item, index) => ({
      id: item.indicationDamId,
      displayName: item.indicationName,
      veevaId: item.indicationDamId || item.id,
    }));
  };

  const transformTherapeuticAreaData = (data) => {
    if (!data || !Array.isArray(data)) return [];
    return data.map((item, index) => ({
      id: item.therapeuticAreaDamId,
      displayName: item.therapeuticAreaDamName,
      veevaId: item.therapeuticAreaDamId || item.id,
    }));
  };

  const transformAudienceData = (data) => {
    if (!data || !Array.isArray(data)) return [];
    return data.map((item, index) => ({
      id: item.audienceDamId,
      displayName: item.audienceDamName,
      veevaId: item.audienceDamId || item.id,
    }));
  };

  const getAudienceData = () => {
    setIsLoading(true);

    getAudienceList((res, err) => {
      setIsLoading(false);
      if (res) {
        // console.log("Audience data received:", res.data);
        const formattedData = transformAudienceData(res.data);
        // console.log("Formatted audience data:", formattedData);
        setAudienceList(formattedData);

        return;
      }

      console.error("Error fetching audiences:", err);
      showError(err);
    });
  };

  const getTherapeuticAreaData = () => {
    setIsLoading(true);

    getTherapeuticAreaList((res, err) => {
      setIsLoading(false);
      if (res) {
        // console.log("Therapeutic area data received:", res.data);
        const formattedData = transformTherapeuticAreaData(res.data);
        // console.log("Formatted therapeutic area data:", formattedData);
        setTherapeuticAreaList(formattedData);

        return;
      }
      console.error("Error fetching therapeutic areas:", err);
      showError(err);
    });
  };

  const getIndicationData = () => {
    setIsLoading(true);

    getIndicationsListFromApi((res, err) => {
      setIsLoading(false);
      if (res) {
        // console.log("Indication data received:", res.data);
        const formattedData = transformIndicationData(res.data);
        // console.log("Formatted indication data:", formattedData);
        setIndicationList(formattedData);

        return;
      }
      console.error("Error fetching indications:", err);
      showError(err);
    });
  };

  // Add function to fetch countries - updated to set state
  const getCountryData = () => {
    setIsLoading(true);

    fetchMarkets((res, err) => {
      setIsLoading(false);
      if (res) {
        // console.log("Country data received:", res.data);
        const formattedData = transformCountryData(res.data);
        // console.log("Formatted country data:", formattedData);

        // Store the formatted data in state
        setCountryOptions(formattedData);

        // Also store the formatted data in the metaDataDropDownList prop if it's not already there
        if (
          !metaDataDropDownList.countryDropDownItems ||
          metaDataDropDownList.countryDropDownItems.length === 0
        ) {
          metaDataDropDownList.countryDropDownItems = formattedData;
        }
        return;
      }
      console.error("Error fetching countries:", err);
      showError(err);
    });
  };

  // Add function to fetch products - updated to set state
  const getProductData = () => {
    setIsLoading(true);

    fetchBrands((res, err) => {
      setIsLoading(false);
      if (res) {
        // console.log("Product data received:", res.data);

        const formattedData = transformProductData(res.data);
        // console.log("Formatted product data:", formattedData);

        // Store the formatted data in state
        setProductOptions(formattedData);

        // Also store the formatted data in the metaDataDropDownList prop if it's not already there
        if (
          !metaDataDropDownList.productDropDownItems ||
          metaDataDropDownList.productDropDownItems.length === 0
        ) {
          metaDataDropDownList.productDropDownItems = formattedData;
        }
        return;
      }
      console.error("Error fetching products:", err);
      showError(err);
    });
  };

  // Add function to fetch topics - updated to set state
  const getTopicData = () => {
    setIsLoading(true);

    fetchTopicsAndSubtopics((res, err) => {
      setIsLoading(false);
      if (res) {
        // console.log("Topic data received:", res.data);

        const formattedData = transformTopicData(res.data);
        // console.log("Formatted topic data:", formattedData);

        setTopicOptions(formattedData);

        // Also store the formatted data in the metaDataDropDownList prop if it's not already there
        if (
          !metaDataDropDownList.topicDropDownItems ||
          metaDataDropDownList.topicDropDownItems.length === 0
        ) {
          metaDataDropDownList.topicDropDownItems = formattedData;
        }
        return;
      }
      console.error("Error fetching topics:", err);
      showError(err);
    });
  };

  // Modified initializeData to populate state variables

  useEffect(() => {
    if (isOpen) {
      // Language depends on country
      if (moduleMetadata?.country?.veevaId && !languageForCountry.length) {
        getLanguagesForSelectedCountry();
      }

      // Segments depend on product + country
      if (
        moduleMetadata?.product?.veevaId &&
        moduleMetadata?.country?.veevaId
      ) {
        getSegmentDataList(
          moduleMetadata.product.veevaId,
          moduleMetadata.country.veevaId,
        );
      }

      // Subtopics depend on product + topic
      if (moduleMetadata?.product?.veevaId && moduleMetadata?.topic?.veevaId) {
        getSubTopicsData(
          moduleMetadata.product.veevaId,
          moduleMetadata.topic.veevaId,
        );
      }

      // Strategic objectives depend on product
      if (moduleMetadata?.product?.veevaId && !strategicObjList.length) {
        getStrategicObjectivesList();
      }

      // Content tone depends on product
      if (moduleMetadata?.product?.veevaId && !contentToneList.length) {
        getContentTone();
      }

      // Draft elements depend on US country
      if (
        moduleMetadata?.country?.veevaId === "unitedStates" &&
        !draftElementsList.length
      ) {
        getDraftElementsData();
      }
    }
  }, [
    isOpen,
    moduleMetadata?.country?.veevaId,
    moduleMetadata?.product?.veevaId,
    moduleMetadata?.topic?.veevaId,
  ]);

  const handleDropdownSelection = (value, type, id) => {
    onMetadataChange(currentModule, type, value, value);
  };
  // Update the getLanguagesForSelectedCountry function to log data more consistently
  const getLanguagesForSelectedCountry = () => {
    if (!moduleMetadata?.country?.veevaId) {
      console.log("No country selected, skipping language fetch");
      return;
    }

    setIsLoading(true);

    getLanguageForCountry(moduleMetadata.country.veevaId, (res, err) => {
      setIsLoading(false);
      if (res) {
        // Transform data to the expected format using utility function
        const formattedData = getLanguageData(res.data);
        // console.log("Language data received:", res.data);
        // console.log("Formatted language data:", formattedData);
        setLanguageForCountry(formattedData);
        return;
      }
      console.error("Error fetching languages:", err);
      showError(err);
    });
  };

  const getSubTopicsData = (productDamId, topicDamId) => {
    if (!productDamId || !topicDamId) {
      console.log("Missing product or topic ID, skipping subtopics fetch");
      return;
    }

    const payload = {
      productDamIds: [productDamId],
      topicDamIds: [topicDamId],
    };

    setIsLoading(true);

    getSubTopics(payload, (res, err) => {
      setIsLoading(false);
      if (res) {
        // Transform data to the expected format with displayName and veevaId
        // console.log("SubTopic data received:", res.data);
        const formattedData = transformSubTopicData(res.data);
        // console.log("Formatted subtopic data:", formattedData);
        setSubTopics(formattedData);
        return;
      }
      console.error("Error fetching subtopics:", err);
      showError(err);
    });
  };

  const getSegmentDataList = (productDamId, countryDamId) => {
    if (!productDamId || !countryDamId) {
      console.log("Missing product or country ID, skipping segments fetch");
      return;
    }

    setIsLoading(true);

    getSegmentList(productDamId, countryDamId, (res, err) => {
      setIsLoading(false);
      if (res) {
        // Transform data to the expected format
        // console.log("Segment data received:", res.data);
        const formattedData = formatSegmentData(res.data);
        // console.log("Formatted segment data:", formattedData);
        setSegmentList(formattedData);
        return;
      }
      console.error("Error fetching segments:", err);
      showError(err);
    });
  };

  const getDraftElementsData = () => {
    setIsLoading(true);
    // console.log("Fetching draft elements");

    getDraftElementsList((res, err) => {
      setIsLoading(false);
      if (res) {
        // Transform data to the expected format
        // console.log("Draft elements data received:", res.data);
        const formattedData = getDraftElementsIncludedData(res.data);
        // console.log("Formatted draft elements data:", formattedData);
        setDraftElementsList(formattedData);
        return;
      }
      console.error("Error fetching draft elements:", err);
      showError(err);
    });
  };

  const getStrategicObjectivesList = () => {
    if (!moduleMetadata?.product?.veevaId) {
      console.log("No product selected, skipping strategic objectives fetch");
      return;
    }

    setIsLoading(true);

    getStrategicObjectivesForBrand(
      moduleMetadata.product.veevaId,
      (res, err) => {
        setIsLoading(false);
        if (res) {
          // Transform data to the expected format
          const formattedData = getStrategiData(res.data);
          setStrategicObjList(formattedData);
          return;
        }
        console.error("Error fetching strategic objectives:", err);
        showError(err);
      },
    );
  };
  const getContentTone = () => {
    if (!moduleMetadata?.product?.veevaId) {
      // console.log("No product selected, skipping content tone fetch");
      return;
    }

    setIsLoading(true);

    getContentToneList(moduleMetadata.product.veevaId, (res, err) => {
      setIsLoading(false);
      if (res) {
        try {
          const formattedData = getContentToneData(res.data);
          setContentToneList(formattedData);
        } catch (parseError) {
          console.error("Error processing content tone data:", parseError);
          showError("Failed to process content tone data");
        }
        return;
      }
      console.error("Error fetching content tone:", err);
      showError(err?.message || "Failed to fetch content tones");
    });
  };
  const getAgency = () => {
    setIsLoading(true);

    getAgencyList((res, err) => {
      setIsLoading(false);
      if (res) {
        const formattedData = getAgencyData(res.data);
        setAgencyList(formattedData);
        return;
      }
      console.error("Error fetching agencies:", err);
      showError(err);
    });
  };

  const handleCancelClick = () => {
    setShowCancelModal(true);
  };

  const confirmCancel = () => {
    setShowCancelModal(false);
    onCancel && onCancel();
  };

  const cancelModal = () => {
    setShowCancelModal(false);
  };

  // Function to check if a specific field has an error
  const hasFieldError = (fieldName) => {
    if (!showValidationErrors) return false;

    // Check the specific field based on moduleMetadata
    switch (fieldName) {
      case "name":
        return !moduleMetadata?.name?.trim();
      case "product":
        return !moduleMetadata?.product?.veevaId;
      case "country":
        return !moduleMetadata?.country?.veevaId;
      case "topic":
        return !moduleMetadata?.topic?.veevaId;
      // case "subTopic":
      //   return !moduleMetadata?.subTopic?.veevaId;
      case "language":
        return !moduleMetadata?.language?.veevaId;
      case "audience":
        return !moduleMetadata?.audience?.veevaId;
      case "therapeuticArea":
        return !moduleMetadata?.therapeuticArea?.veevaId;
      case "communicationObjectives":
        return !moduleMetadata?.communicationObjectives?.trim() === "";
      case "brandStyleGuidelines":
        return !moduleMetadata?.brandStyleGuidelines?.trim() === "";
      case "segment":
        return Array.isArray(moduleMetadata?.segment)
          ? moduleMetadata.segment.length === 0
          : !moduleMetadata?.segment;
      case "indication":
        return Array.isArray(moduleMetadata?.indication)
          ? moduleMetadata.indication.length === 0
          : !moduleMetadata?.indication;
      case "strategicObjective":
        return Array.isArray(moduleMetadata?.strategicObjective)
          ? moduleMetadata.strategicObjective.length === 0
          : !moduleMetadata?.strategicObjective;
      case "agency":
        return !moduleMetadata?.agency?.veevaId;
      case "contentTone":
        return !moduleMetadata?.contentTone?.veevaId;
      case "draftElementIncluded":
        return (
          moduleMetadata?.country?.veevaId === "unitedStates" &&
          (Array.isArray(moduleMetadata?.draftElementIncluded)
            ? moduleMetadata.draftElementIncluded.length === 0
            : !moduleMetadata?.draftElementIncluded?.veevaId)
        );
      case "elements":
        return (
          moduleMetadata?.selectedElements?.claims?.length === 0 &&
          moduleMetadata?.selectedElements?.reusableTexts?.length === 0 &&
          moduleMetadata?.selectedElements?.components?.length === 0
        );
      case "claims":
        return moduleMetadata?.selectedElements?.claims?.length === 0;
      default:
        return false;
    }
  };

  // Check if metadata is complete to enable next/generate button
  const validateMetaDataSelection = () => {
    // Make sure everything exists before validation
    if (!moduleMetadata) return false;

    const hasAvailableClaims = elements?.claims && elements.claims.length > 0;
    const hasAvailableRTs =
      elements?.reusableTexts && elements.reusableTexts.length > 0;

    const hasSelectedClaims =
      moduleMetadata?.selectedElements?.claims?.length > 0;
    const hasSelectedRTs =
      moduleMetadata?.selectedElements?.reusableTexts?.length > 0;

    //  at least ONE claim OR ONE reusable text when available
    const hasValidElementSelection =
      (!hasAvailableClaims && !hasAvailableRTs) || // If no elements available
      hasSelectedClaims ||
      hasSelectedRTs;

    const validation = {
      name: !!moduleMetadata?.name?.trim(),
      product: !!moduleMetadata?.product?.veevaId,
      country: !!moduleMetadata?.country?.veevaId,
      topic: !!moduleMetadata?.topic?.veevaId,
      // subTopic: !!moduleMetadata?.subTopic?.veevaId,
      language: !!moduleMetadata?.language?.veevaId,
      audience: !!moduleMetadata?.audience?.veevaId,
      therapeuticArea: !!moduleMetadata?.therapeuticArea?.veevaId,
      communicationObjectives:
        !!moduleMetadata?.communicationObjectives?.trim(),
      segment: Array.isArray(moduleMetadata?.segment)
        ? moduleMetadata.segment.length > 0
        : !!moduleMetadata?.segment,
      draftElementsValid:
        moduleMetadata?.country?.veevaId !== "unitedStates" ||
        (Array.isArray(moduleMetadata?.draftElementIncluded)
          ? moduleMetadata.draftElementIncluded.length > 0
          : !!moduleMetadata?.draftElementIncluded?.veevaId),
      agency: !!moduleMetadata?.agency?.veevaId,
      // Combined element validation - allows either claims OR reusable texts
      elementsSelected: hasValidElementSelection,
    };

    // Return true only if all required validations pass
    return Object.values(validation).every((value) => value === true);
  };
  // Check if at least one element is selected to enable next/generate button
  const isNextEnabled = validateMetaDataSelection();

  // Determine if this is the last module
  const isLastModule = currentModule === totalModules;

  const steps = Array.from(
    { length: totalModules },
    (_, i) => `Module_${i + 1}`,
  );

  // Render dropdowns - helper function to handle empty options properly
  const renderDropdownOptions = (options) => {
    if (!options || !Array.isArray(options) || options.length === 0) {
      return [];
    }

    // Check if options need to be transformed (i.e., they are from API and don't have the expected format)
    if (
      options.length > 0 &&
      options[0] &&
      !options[0].displayName &&
      !options[0].veevaId
    ) {
      // Determine the type of data based on object properties
      if (options[0].productName && options[0].productDamId) {
        return transformProductData(options);
      } else if (options[0].countryName || options[0].name) {
        return transformCountryData(options);
      } else if (options[0].topicName && options[0].topicDamId) {
        return transformTopicData(options);
      } else if (options[0].subTopicName && options[0].subTopicDamId) {
        return transformSubTopicData(options);
      }
    }

    // Ensure each option has an id property and displayName required by DropDownWithSearch and MultiSelectDropDownWithInlineSearch
    return options.map((option) => ({
      ...option,
      id: option.id || option.veevaId,
      displayName: option.displayName || option.name || "",
      isSelectable: !(option.isNotSelectable === true),
    }));
  };

  // Helper function to initialize empty arrays for multi-select fields
  const initializeEmptyArrayForMultiSelect = (value) => {
    return Array.isArray(value) ? value : value ? [value] : [];
  };

  // Helper function to check if a field is required
  const isFieldRequired = (fieldName) => {
    const requiredFields = [
      "name",
      "country",
      "product",
      "language",
      "topic",
      // "subTopic",
      "audience",
      "therapeuticArea",
      "segment",
      // "strategicObjective",
      "agency",
      "communicationObjectives",
      "contetTone",
      // "brandStyleGuidelines"
    ];

    // Draft elements are only required for US
    if (fieldName === "draftElementIncluded") {
      return moduleMetadata?.country?.veevaId === "unitedStates";
    }

    return requiredFields.includes(fieldName);
  };

  // Add field error styling
  const FieldError = styled.div`
    color: #ff3b30;
    font-size: 12px;
    margin-top: 4px;
  `;

  if (!isOpen) return null;

  const handlePreviewToggle = () => {
    setIsPreviewOpen((prev) => {
      const willOpen = !prev;

      // When opening preview, set active slide to match current page
      if (willOpen && assetId?.slideIds?.length > 0) {
        // Safely handle pageId - it might be undefined, null, or already a string
        const currentPageId = pageId ? String(pageId) : null;

        const slideForCurrentPage = validSlides.find((slide) => {
          // Check if slide exists and has valid properties
          if (!slide) return false;

          // Compare with currentPageId if it exists
          if (currentPageId) {
            return (
              slide.id === currentPageId ||
              (slide.name && slide.name === currentPageId) ||
              (slide.id && slide.id.includes(currentPageId))
            );
          }

          return false;
        });

        if (slideForCurrentPage) {
          setActiveSlideId(slideForCurrentPage.id);
        } else {
          // Fallback to first slide
          setActiveSlideId(assetId.slideIds[0]);
        }
      }

      return willOpen;
    });
  };

  const validSlides = assetId
    ? assetId.slideIds.map((id, index) => {
        const signedUrlObj = assetId.signedUrls.find(
          (url) => url.pageId === id,
        );
        return {
          id: id,
          name: assetId.slidenums[index],
          signedUrl: signedUrlObj ? signedUrlObj.signedUrl : null,
        };
      })
    : [];

  const selectedSlide =
    validSlides.length > 0
      ? {
          signedUrls: validSlides.map((slide) => ({
            pageId: slide.id,
            signedUrl: slide.signedUrl,
          })),
        }
      : null;

  const activeSlideData = validSlides.find(
    (slide) => slide.id === activeSlideId,
  );

  const CheckBoxComponent = ({
    moduleIndex,
    isSelected,
    isCreated,
    canBeUnchecked,
  }) => {
    return (
      <div className={styles.checkboxWrapper}>
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => {
            // Parent will handle deletion if needed
            handleCheckboxChange(moduleIndex, e.target.checked);
          }}
          className={styles.moduleCheckbox}
        />
      </div>
    );
  };
  const formatRationalText = (text) => {
    if (!text) return "No rationale available";

    // OR after a newline (considering both \n and <br>)
    const lines = text.split(/(?<=\n)(?=\d+\.\s)|(?<=^)(?=\d+\.\s)/g);

    // Process each line
    let result = "";
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();
      if (line) {
        if (i > 0) {
          result += "<br>";
        }
        result += line;
      }
    }

    return result;
  };

  const shouldShowGenerateCMSD = () => {
    // For both flows, we need to check if this is the last SELECTED module

    if (!selectedModules || selectedModules.length === 0) {
      // Fallback: show on last numeric module
      return currentModule === totalModules;
    }

    // Safety check
    if (currentModule < 1 || currentModule > totalModules) {
      return false;
    }

    // Check if current module is selected
    const isCurrentSelected = selectedModules[currentModule - 1];

    if (!isCurrentSelected) {
      return false; // Current module is not selected
    }

    // Check if any modules AFTER current are selected
    for (let i = currentModule; i < totalModules; i++) {
      if (selectedModules[i]) {
        // Found a selected module after current - show NEXT
        return false;
      }
    }

    // Current is the last selected module in the sequence - show GENERATE CMSD
    return true;
  };

  const isCurrentModuleSelected = selectedModules[currentModule - 1] || false;
  const showGenerateButton = shouldShowGenerateCMSD();
  const currentModuleName = getModuleDisplayName(currentModule - 1);

  // Helper function to check if module has any elements
  const hasElements = (moduleIndex) => {
    const moduleElems = elements; // Current module elements
    if (!moduleElems) return false;

    const hasClaims = moduleElems.claims && moduleElems.claims.length > 0;
    const hasReusableTexts =
      moduleElems.reusableTexts && moduleElems.reusableTexts.length > 0;
    const hasComponents =
      moduleElems.components && moduleElems.components.length > 0;

    return hasClaims || hasReusableTexts || hasComponents;
  };

  const ReasonText = () => {
    return (
      <span className={styles.rightRationaleHead}>
        <img src={bluIcon} alt="genai" />
      </span>
    );
  };
  const getFirstLetters = () => {
    const userName = !!keycloak.authenticated
      ? keycloak.tokenParsed.name
      : null;
    if (!userName) return "";
    const nameArray = userName.split(" ");
    const firstLetters = nameArray.map((name) => name.charAt(0));
    return firstLetters.slice(0, 2).join("").toUpperCase();
  };
  const lastMeta =
    userCollectedMeta && userCollectedMeta.length > 0
      ? userCollectedMeta[userCollectedMeta.length - 1]
      : {};

  const formatModuleText = (meta) => {
    if (!meta) return "Creating modules";

    const { product, country, topic, objective } = meta;
    return `Creating modules for ${product || ""}, ${country || ""}, ${
      topic || ""
    } and ${(objective || "").toLowerCase()}`;
  };
  const getSourceCombinationDisplay = (index) => {
    const sources = multipleModulesData[index]?.sourceCombination ?? [];

    if (!sources.length) return "-";

    // Since sourceCombination is already in ['Slide_1', 'Slide_3'] format
    // Just join them with comma and space
    return sources.join(", ");
  };

  return (
    <ModalOverlay className={styles.modalOverlayNew}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        {/* <CloseButton onClick={onClose}>×</CloseButton> */}

        {/* <CircularProgressBar isloading={isApiLoading} /> */}
        <div className={styles.MEMHeadBoxNew}>
          <div className={styles.MEMTopBox}>
            <span>MODULE SELECTION</span>
            <div>
              <PreviewToggle
                isActive={isPreviewOpen}
                onToggle={handlePreviewToggle}
              />
            </div>
          </div>
          <div className={styles.chatGreyBox}>
            <span className={styles.chatGreyBoxUser}>{getFirstLetters()}</span>
            <span className={styles.chatGreyBoxText}>
              {formatModuleText(lastMeta)}
            </span>
          </div>
        </div>
        {/* <ModuleStepper currentStep={currentModule} steps={steps}>
          <PreviewToggle
            isActive={isPreviewOpen}
            onToggle={handlePreviewToggle}
          />
        </ModuleStepper> */}
        {elementsLoading ? (
          <>
            <div className={styles.moduleCreationNewClass}>
              <GenaiLoader isloading={true} />
            </div>
          </>
        ) : (
          <>
            {isPreviewOpen ? (
              <>
                {true ? (
                  <>
                    <div className={styles.moduleCreationNewClass}>
                      <div className={styles.leftMEM}>
                        {/* Show slide tabs on the left */}
                        {selectedSlide?.signedUrls?.length > 0 && (
                          <div className={styles.contASlideAnalyse}>
                            {selectedSlide.signedUrls.map(
                              (signedUrlObj, index) => {
                                const slideId = signedUrlObj.pageId;
                                const slideName =
                                  assetId?.slidenums?.[index] ||
                                  `Slide_${index + 1}`;
                                const isSelected = activeSlideId === slideId;
                                const slideImage = signedUrlObj.signedUrl;
                                return (
                                  <div
                                    key={slideId}
                                    className={`${styles.fullBOX} ${
                                      isSelected ? styles.selectedSlide : ""
                                    }`}
                                    onClick={() => {
                                      setActiveSlideId(slideId);
                                      setCurrentSlideIndex(index);
                                    }}
                                  >
                                    <div
                                      className={`${
                                        styles.sliderecBoxAnalyse
                                      } ${styles.elemSection} ${
                                        isSelected ? styles.activeModule : ""
                                      }`}
                                    >
                                      <span className={styles.analyseboxOne}>
                                        <img
                                          src={slideImage}
                                          alt={`${slideName} thumbnail`}
                                          className={styles.imgSlideAnalyse}
                                          onError={(e) => {
                                            // If image fails to load, show a placeholder
                                            e.target.style.display = "none";
                                            const placeholder =
                                              document.createElement("div");
                                            placeholder.className =
                                              styles.thumbnailPlaceholder;
                                            placeholder.textContent =
                                              slideName.charAt(0);
                                            e.target.parentElement.appendChild(
                                              placeholder,
                                            );
                                          }}
                                        />
                                        <span className={styles.analyseTextMEM}>
                                          {slideName}
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                );
                              },
                            )}
                          </div>
                        )}
                      </div>

                      <div className={styles.rightMEMNew}>
                        <ShowSlideImgNew
                          slideIndex={currentSlideIndex} // Use the current slide index
                          selectedSlide={selectedSlide} // Pass the full selectedSlide object
                          isPreviewOpen={isPreviewOpen}
                          singleSlideMode={true} // Set to true for single slide display
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <SlideTabsControl
                      slides={validSlides}
                      activeSlide={activeSlideId}
                      onSlideChange={setActiveSlideId}
                      singleTabMode={true}
                    />
                    <ShowSlideImg
                      slideIndex={0} // Always 0 since we're passing only one slide else currentSlideIndex
                      selectedSlide={{
                        ...selectedSlide,
                        signedUrls: activeSlideData
                          ? [
                              {
                                pageId: activeSlideData.id,
                                signedUrl: activeSlideData.signedUrl,
                              },
                            ]
                          : [],
                      }}
                      isPreviewOpen={isPreviewOpen}
                      singleSlideMode={true}
                    />
                  </>
                )}
              </>
            ) : (
              <>
                <div className={styles.moduleCreationNewClass}>
                  <div className={styles.leftMEM}>
                    <div className={styles.contASlideAnalyse}>
                      {Array.from({ length: totalModules }, (_, index) => {
                        const moduleIndex = index;
                        const isSelected =
                          selectedModules[moduleIndex] || false;
                        const isCreated = createdModules[moduleIndex] || false;
                        const canBeUnchecked =
                          canModuleBeUnchecked(moduleIndex);
                        const moduleName = getModuleDisplayName(moduleIndex);
                        const isCurrentModule =
                          currentModule === moduleIndex + 1;

                        return (
                          <div
                            key={moduleIndex}
                            className={`${styles.fullBOX} ${
                              !isSelected ? styles.unselectedModule : ""
                            }`}
                            onClick={() => handleModuleClick(moduleIndex)}
                          >
                            <CheckBoxComponent
                              moduleIndex={moduleIndex}
                              isSelected={isSelected}
                              isCreated={isCreated}
                              canBeUnchecked={canBeUnchecked}
                            />
                            <div
                              className={`${styles.sliderecBoxAnalyse} ${
                                isCurrentModule ? styles.activeModule : ""
                              }`}
                            >
                              <span className={styles.analyseboxOne}>
                                {/* <img
                                  className={styles.imgSlideAnalyse}
                                  src={moduleimage}
                                  alt="module"
                                /> */}
                                <span
                                  className={styles.analyseTextMEM}
                                  style={{ marginLeft: 0 }}
                                >
                                  {moduleName}
                                  {/* <br /> */}
                                </span>
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className={styles.rightMEMNew}>
                    <span className={styles.analyseTextMEMNew}>
                      {currentModuleName}
                    </span>
                    <CustomAccordion title="reasoning" icon={<ReasonText />}>
                      <div className={styles.rightRationale}>
                        {isRationaleLoading ? (
                          <span style={{ color: "#54565b;" }}>
                            Loading reasoning...
                          </span>
                        ) : (
                          <span
                            className={styles.rightmsg}
                            dangerouslySetInnerHTML={{
                              __html:
                                formatRationalText(rationalData) ||
                                "No rationale available",
                            }}
                          />
                        )}
                        {multiModuleCreation && (
                          <div>
                            <span className={styles.slideTextRationale}>
                              Slides used:
                            </span>
                            <span className={styles.fontRationale}>
                              {getSourceCombinationDisplay(currentModule - 1)}
                            </span>
                          </div>
                        )}
                      </div>
                    </CustomAccordion>
                    <CustomAccordion title="metadata information">
                      <ModuleContent>
                        {/* Metadata Section */}
                        <MetadataSection>
                          <MetadataRow style={{ marginBottom: "1px" }}>
                            <MetadataItem>
                              <CustomTextField
                                label="Module Name"
                                normalinput={true}
                                value={moduleMetadata?.name}
                                handleChange={(value) =>
                                  handleDropdownSelection(value, "name")
                                }
                                charLimit={2000}
                                required={isFieldRequired("name")}
                                disabled={moduleExists || false}
                              />
                              {/* </CustomTextFieldContainer> */}
                              {hasFieldError("name") && (
                                <FieldError>Module name is required</FieldError>
                              )}
                            </MetadataItem>
                            <MetadataItem>
                              <DropdownContainer
                                className={
                                  hasFieldError("country") ? "error" : ""
                                }
                              >
                                <DropDownWithSearch
                                  options={{
                                    items: renderDropdownOptions(
                                      countryOptions.length > 0
                                        ? countryOptions
                                        : metaDataDropDownList?.countryDropDownItems,
                                    ),
                                    value:
                                      moduleMetadata?.country ||
                                      findMatchingOption(
                                        userMeta?.country,
                                        countryOptions,
                                      ),
                                    handleChange: (value) =>
                                      handleDropdownSelection(value, "country"),
                                    label: "Primary Country",
                                    placeholder: "Select Country",
                                    isDataTypeObject: true,
                                    required: isFieldRequired("country"),
                                    disabled:
                                      moduleExists ||
                                      (moduleMetadata?.country?.veevaId
                                        ? true
                                        : false),
                                  }}
                                />
                              </DropdownContainer>
                              {hasFieldError("country") && (
                                <FieldError>
                                  Primary Country is required
                                </FieldError>
                              )}
                            </MetadataItem>
                            <MetadataItem>
                              <DropdownContainer
                                className={
                                  hasFieldError("product") ? "error" : ""
                                }
                              >
                                <DropDownWithSearch
                                  options={{
                                    items: renderDropdownOptions(
                                      productOptions.length > 0
                                        ? productOptions
                                        : metaDataDropDownList?.productDropDownItems,
                                    ),
                                    value:
                                      moduleMetadata?.product ||
                                      findMatchingOption(
                                        userMeta?.product,
                                        productOptions,
                                      ),
                                    handleChange: (value) =>
                                      handleDropdownSelection(value, "product"),
                                    label: "Primary Product",
                                    placeholder: "Select Product",
                                    isDataTypeObject: true,
                                    required: isFieldRequired("product"),
                                    disabled:
                                      moduleExists ||
                                      (moduleMetadata?.product?.veevaId
                                        ? true
                                        : false),
                                  }}
                                />
                              </DropdownContainer>
                              {hasFieldError("product") && (
                                <FieldError>
                                  Primary Product is required
                                </FieldError>
                              )}
                            </MetadataItem>
                          </MetadataRow>

                          <MetadataRow style={{ marginBottom: "1px" }}>
                            <MetadataItem>
                              <DropdownContainer
                                className={
                                  hasFieldError("indication") ? "error" : ""
                                }
                              >
                                <MultiSelectDropDownWithInlineSearch
                                  options={{
                                    items:
                                      renderDropdownOptions(indicationList),
                                    value: initializeEmptyArrayForMultiSelect(
                                      moduleMetadata?.indication,
                                    ),
                                    handleChange: (value) =>
                                      handleDropdownSelection(
                                        value,
                                        "indication",
                                      ),
                                    label: "Indication",
                                    placeholder: "Select Indication",
                                    isDataTypeObject: true,
                                    required: isFieldRequired("indication"),
                                    disabled: moduleExists || false,
                                  }}
                                />
                              </DropdownContainer>
                              {hasFieldError("indication") && (
                                <FieldError>Indication is required</FieldError>
                              )}
                            </MetadataItem>
                            <MetadataItem>
                              <DropdownContainer
                                className={
                                  hasFieldError("language") ? "error" : ""
                                }
                              >
                                <DropDownWithSearch
                                  options={{
                                    items:
                                      renderDropdownOptions(languageForCountry),
                                    value: moduleMetadata?.language || "",
                                    handleChange: (value) =>
                                      handleDropdownSelection(
                                        value,
                                        "language",
                                      ),
                                    label: "Language",
                                    placeholder: !moduleMetadata?.country
                                      ? "Select a Country first"
                                      : "Select Language",
                                    isDataTypeObject: true,
                                    required: isFieldRequired("language"),
                                    disabled:
                                      moduleExists || !moduleMetadata?.country,
                                    isDisabledDueToParent:
                                      !moduleMetadata?.country,
                                    parentFieldName: "Country",
                                    currentFieldName: "Language",
                                  }}
                                />
                              </DropdownContainer>
                              {hasFieldError("language") && (
                                <FieldError>Language is required</FieldError>
                              )}
                            </MetadataItem>
                            <MetadataItem>
                              <DropdownContainer
                                className={
                                  hasFieldError("topic") ? "error" : ""
                                }
                              >
                                <DropDownWithSearch
                                  options={{
                                    items: renderDropdownOptions(
                                      topicOptions.length > 0
                                        ? topicOptions
                                        : metaDataDropDownList?.topicDropDownItems,
                                    ),
                                    value: moduleMetadata?.topic || {
                                      id: "",
                                      displayName: "",
                                      veevaId: "",
                                      isSelectable: true,
                                    },
                                    handleChange: (value) =>
                                      handleDropdownSelection(value, "topic"),
                                    label: "Topic",
                                    placeholder: "Select Topic",
                                    isDataTypeObject: true,
                                    required: isFieldRequired("topic"),
                                    disabled: moduleExists || false,
                                  }}
                                />
                              </DropdownContainer>
                              {hasFieldError("topic") && (
                                <FieldError>Topic is required</FieldError>
                              )}
                            </MetadataItem>
                          </MetadataRow>

                          <MetadataRow>
                            <MetadataItem>
                              <DropdownContainer
                                className={
                                  hasFieldError("subTopic") ? "error" : ""
                                }
                              >
                                <DropDownWithSearch
                                  options={{
                                    items: renderDropdownOptions(subTopics),
                                    value: moduleMetadata?.subTopic || null,
                                    handleChange: (value) =>
                                      handleDropdownSelection(
                                        value,
                                        "subTopic",
                                      ),

                                    label: "Sub-Topic",
                                    placeholder:
                                      !moduleMetadata?.topic ||
                                      !moduleMetadata?.product
                                        ? "Select Product and Topic first"
                                        : "Select Sub-Topic",
                                    isDataTypeObject: true,
                                    // required: isFieldRequired("subTopic"),
                                    disabled:
                                      moduleExists ||
                                      !moduleMetadata?.topic ||
                                      !moduleMetadata?.product,
                                    isDisabledDueToParent:
                                      !moduleMetadata?.topic ||
                                      !moduleMetadata?.product,
                                    parentFieldName: "Product and Topic",
                                    currentFieldName: "Sub-Topic",
                                  }}
                                />
                              </DropdownContainer>
                              {hasFieldError("subTopic") && (
                                <FieldError>Sub-Topic is required</FieldError>
                              )}
                            </MetadataItem>
                            <MetadataItem>
                              <DropdownContainer
                                className={
                                  hasFieldError("audience") ? "error" : ""
                                }
                              >
                                <DropDownWithSearch
                                  options={{
                                    items: renderDropdownOptions(
                                      metaDataDropDownList?.audienceDropDownItems ||
                                        audienceList,
                                    ),
                                    value: moduleMetadata?.audience || "",
                                    handleChange: (value) =>
                                      handleDropdownSelection(
                                        value,
                                        "audience",
                                      ),
                                    label: "Audience",
                                    placeholder: "Select Audience",
                                    isDataTypeObject: true,
                                    required: isFieldRequired("audience"),
                                    disabled: moduleExists || false,
                                  }}
                                />
                              </DropdownContainer>
                              {hasFieldError("audience") && (
                                <FieldError>Audience is required</FieldError>
                              )}
                            </MetadataItem>
                            <MetadataItem>
                              <DropdownContainer
                                className={
                                  hasFieldError("therapeuticArea")
                                    ? "error"
                                    : ""
                                }
                              >
                                <DropDownWithSearch
                                  options={{
                                    items: renderDropdownOptions(
                                      metaDataDropDownList?.therapeuticAreaDropDownItems ||
                                        therapeuticAreaList,
                                    ),
                                    value:
                                      moduleMetadata?.therapeuticArea || "",
                                    handleChange: (value) =>
                                      handleDropdownSelection(
                                        value,
                                        "therapeuticArea",
                                      ),
                                    label: "Therapeutic Area",
                                    placeholder: "Select Therapeutic Area",
                                    isDataTypeObject: true,
                                    required:
                                      isFieldRequired("therapeuticArea"),
                                    disabled: moduleExists || false,
                                  }}
                                />
                              </DropdownContainer>
                              {hasFieldError("therapeuticArea") && (
                                <FieldError>
                                  Therapeutic Area is required
                                </FieldError>
                              )}
                            </MetadataItem>
                          </MetadataRow>

                          <MetadataRow style={{ marginBottom: "0px" }}>
                            <MetadataItem>
                              <DropdownContainer
                                className={
                                  hasFieldError("segment") ? "error" : ""
                                }
                              >
                                <MultiSelectDropDownWithInlineSearch
                                  options={{
                                    items: matchSegmentItems,
                                    value: initializeEmptyArrayForMultiSelect(
                                      moduleMetadata?.segment,
                                    ),
                                    handleChange: (value) =>
                                      handleDropdownSelection(value, "segment"),
                                    label: "Segment",
                                    placeholder:
                                      !moduleMetadata?.product ||
                                      !moduleMetadata?.country
                                        ? "Select Product and Country first"
                                        : "Select Segment",
                                    isDataTypeObject: true,
                                    required: isFieldRequired("segment"),
                                    disabled:
                                      moduleExists ||
                                      !moduleMetadata?.product ||
                                      !moduleMetadata?.country,
                                    isDisabledDueToParent:
                                      !moduleMetadata?.product ||
                                      !moduleMetadata?.country,
                                    parentFieldName: "Product and Country",
                                    currentFieldName: "Segment",
                                  }}
                                />
                              </DropdownContainer>
                              {hasFieldError("segment") && (
                                <FieldError>Segment is required</FieldError>
                              )}
                            </MetadataItem>
                            <MetadataItem>
                              {/* <MetadataLabel>Strategic Objective{isFieldRequired("strategicObjective") && <RequiredMark>*</RequiredMark>}</MetadataLabel> */}
                              <DropdownContainer
                                className={
                                  hasFieldError("strategicObjective")
                                    ? "error"
                                    : ""
                                }
                              >
                                <MultiSelectDropDownWithInlineSearch
                                  options={{
                                    items:
                                      renderDropdownOptions(strategicObjList),
                                    value: initializeEmptyArrayForMultiSelect(
                                      moduleMetadata?.strategicObjective,
                                    ),
                                    handleChange: (value) =>
                                      handleDropdownSelection(
                                        value,
                                        "strategicObjective",
                                      ),
                                    label: "Strategic Objective",
                                    placeholder: !moduleMetadata?.product
                                      ? "Select Product first"
                                      : "Select Strategic Objective",
                                    isDataTypeObject: true,
                                    required: false,
                                    disabled:
                                      moduleExists || !moduleMetadata?.product,
                                    isDisabledDueToParent:
                                      !moduleMetadata?.product,
                                    parentFieldName: "Product",
                                    currentFieldName: "Strategic Objective",
                                  }}
                                />
                              </DropdownContainer>
                              {hasFieldError("strategicObjective") && (
                                <FieldError>
                                  Strategic Objective is required
                                </FieldError>
                              )}
                            </MetadataItem>

                            <MetadataItem>
                              <DropdownContainer
                                className={
                                  hasFieldError("contentTone") ? "error" : ""
                                }
                              >
                                <DropDownWithSearch
                                  options={{
                                    items:
                                      renderDropdownOptions(contentToneList),
                                    value: moduleMetadata?.contentTone || "",
                                    handleChange: (value) =>
                                      handleDropdownSelection(
                                        value,
                                        "contentTone",
                                      ),
                                    label: "Content Tone",
                                    placeholder: !moduleMetadata?.product
                                      ? "Select Product first"
                                      : "Search and Select Content Tone",
                                    isDataTypeObject: true,
                                    required: false,
                                    disabled:
                                      moduleExists || !moduleMetadata?.product,
                                    isDisabledDueToParent:
                                      !moduleMetadata?.product,
                                    parentFieldName: "Product",
                                    currentFieldName: "Content Tone",
                                  }}
                                />
                              </DropdownContainer>
                              {hasFieldError("contentTone") && (
                                <FieldError>
                                  Content Tone is required
                                </FieldError>
                              )}
                            </MetadataItem>
                          </MetadataRow>

                          <MetadataRow style={{ marginBottom: "0px" }}>
                            <MetadataItem>
                              {/* <MetadataLabel>Creative Agency{isFieldRequired("agency") && <RequiredMark>*</RequiredMark>}</MetadataLabel> */}
                              <DropdownContainer
                                className={
                                  hasFieldError("agency") ? "error" : ""
                                }
                              >
                                <DropDownWithSearch
                                  options={{
                                    items: renderDropdownOptions(agencyList),
                                    value: moduleMetadata?.agency || "",
                                    handleChange: (value) =>
                                      handleDropdownSelection(value, "agency"),
                                    label: "Creative Agency",
                                    placeholder: "Select Agency",
                                    isDataTypeObject: true,
                                    required: isFieldRequired("agency"),
                                    disabled: moduleExists || false,
                                  }}
                                />
                              </DropdownContainer>
                              {hasFieldError("agency") && (
                                <FieldError>
                                  Creative Agency is required
                                </FieldError>
                              )}
                            </MetadataItem>

                            <MetadataItem>
                              <CustomTextField
                                style={{ height: "40px" }}
                                label="Brand Style Guidelines Link"
                                normalinput={true}
                                value={
                                  moduleMetadata?.brandStyleGuidelines || ""
                                }
                                handleChange={(value) =>
                                  handleDropdownSelection(
                                    value,
                                    "brandStyleGuidelines",
                                  )
                                }
                                charLimit={2000}
                                required={false}
                                disabled={moduleExists || false}
                              />
                              {hasFieldError("brandStyleGuidelines") && (
                                <FieldError>
                                  Brand Style Guidelines is required
                                </FieldError>
                              )}
                            </MetadataItem>

                            {moduleMetadata?.country?.veevaId ===
                            "unitedStates" ? (
                              <MetadataItem>
                                <DropdownContainer
                                  className={
                                    hasFieldError("draftElementIncluded")
                                      ? "error"
                                      : ""
                                  }
                                >
                                  <MultiSelectDropDownWithInlineSearch
                                    options={{
                                      items:
                                        renderDropdownOptions(
                                          draftElementsList,
                                        ),
                                      value: initializeEmptyArrayForMultiSelect(
                                        moduleMetadata?.draftElementIncluded,
                                      ),
                                      handleChange: (value) =>
                                        handleDropdownSelection(
                                          value,
                                          "draftElementIncluded",
                                        ),
                                      label: "Draft Element Included",
                                      placeholder: "Select Draft Element",
                                      isDataTypeObject: true,
                                      required: isFieldRequired(
                                        "draftElementIncluded",
                                      ),
                                      disabled: moduleExists || false,
                                    }}
                                  />
                                </DropdownContainer>
                                {hasFieldError("draftElementIncluded") && (
                                  <FieldError>
                                    Draft Element is required
                                  </FieldError>
                                )}
                              </MetadataItem>
                            ) : (
                              <MetadataItem></MetadataItem>
                            )}
                          </MetadataRow>

                          <MetadataRow style={{ marginBottom: "0px" }}>
                            <MetadataItem fullWidth>
                              <CustomTextField
                                style={{ marginBottom: "0px" }}
                                label="Communication Objectives"
                                multiline={true}
                                rows={4}
                                rowsMax={6}
                                value={
                                  moduleMetadata?.communicationObjectives || ""
                                }
                                handleChange={(value) =>
                                  handleDropdownSelection(
                                    value,
                                    "communicationObjectives",
                                  )
                                }
                                charLimit={2000}
                                required={isFieldRequired(
                                  "communicationObjectives",
                                )}
                                disabled={moduleExists || false}
                                isGenAiComObj={true}
                              />

                              {hasFieldError("communicationObjectives") && (
                                <FieldError>
                                  Communication Objectives is required
                                </FieldError>
                              )}
                            </MetadataItem>
                          </MetadataRow>
                        </MetadataSection>
                      </ModuleContent>
                    </CustomAccordion>

                    <CustomAccordion contentPadding="20px" title="elements">
                      <ModuleContent>
                        {/* No Elements Warning */}
                        {elementsLoading ? (
                          <></>
                        ) : (
                          !elements?.claims?.length &&
                          !elements?.reusableTexts?.length &&
                          !elements?.components?.length && (
                            <div
                              style={{
                                backgroundColor: "#FFF9E6",
                                border: "1px solid #FFD700",
                                borderRadius: "4px",
                                padding: "12px 16px",
                                marginBottom: "20px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ marginRight: "12px" }}>
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM11 7H13V13H11V7ZM11 15H13V17H11V15Z"
                                    fill="#FFD700"
                                  />
                                </svg>
                              </div>
                              <div>
                                <p
                                  style={{
                                    margin: 0,
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    color: "#1e1e1e",
                                  }}
                                >
                                  No elements found for this module
                                </p>
                                <p
                                  style={{
                                    margin: "4px 0 0",
                                    fontSize: "12px",
                                    color: "#54565b",
                                  }}
                                >
                                  This module has no claims, reusable texts, or
                                  components. It will be skipped in the module
                                  creation process.
                                </p>
                              </div>
                            </div>
                          )
                        )}
                        {/* Elements Section */}
                        <ElementsSection>
                          {showValidationErrors &&
                            hasFieldError("elements") && (
                              <ElementsErrorMessage>
                                Please select at least one element
                              </ElementsErrorMessage>
                            )}
                          {showValidationErrors && hasFieldError("claims") && (
                            <ElementsErrorMessage>
                              Please select at least one claim to proceed
                            </ElementsErrorMessage>
                          )}
                          <ElementPreviewBox>
                            {elements ? (
                              // <div key={pageId}>
                              <ModulePreviewData
                                key={`module-preview-${currentModule}-${pageId}`} // Add key to force re-render when module changes
                                modulePreviewData={elements}
                                onlyClaimCardsVisible={true}
                                isClaimsSelectable={true}
                                selectedItems={
                                  moduleMetadata?.selectedElements || {
                                    claims: [],
                                    reusableTexts: [],
                                    components: [],
                                  }
                                }
                                currentModule={currentModule}
                                setSelectedItems={(selectedElements) =>
                                  onMetadataChange(
                                    currentModule,
                                    "selectedElements",
                                    selectedElements,
                                  )
                                }
                                onUsageTypeChange={onUsageTypeChange}
                                onElementDeselect={onElementDeselect}
                                moduleId={`${currentModule}-${pageId}`}
                              />
                            ) : (
                              // </div>
                              // </div>
                              <div className="d-flex justify-content-center align-items-center w-100 h-100">
                                <span className="text-muted">
                                  No elements found
                                </span>
                              </div>
                            )}
                          </ElementPreviewBox>
                        </ElementsSection>
                      </ModuleContent>
                    </CustomAccordion>
                  </div>
                </div>
              </>
            )}
          </>
        )}
        <ButtonsSection>
          <BackButton
            onClick={onBack}
            disabled={isLoading || buttonLoading || elementsLoading}
          >
            BACK
          </BackButton>
          <RightButtons>
            {showGenerateButton ? (
              <NextButton
                onClick={attemptProceed}
                disabled={
                  !isCurrentModuleSelected || // SIMPLE CHECK: Disable if module not selected
                  !isNextEnabled ||
                  isLoading ||
                  buttonLoading ||
                  elementsLoading
                }
                isEnabled={isNextEnabled}
              >
                PROCEED{" "}
                {buttonLoading && (
                  <Spinner
                    animation="border"
                    size="sm"
                    variant="primary"
                    text="NEXT"
                    className="ml-1"
                  />
                )}
              </NextButton>
            ) : (
              <NextButton
                onClick={attemptProceed}
                disabled={
                  isLoading ||
                  !isCurrentModuleSelected ||
                  buttonLoading ||
                  elementsLoading ||
                  (!elements?.claims?.length &&
                  !elements?.reusableTexts?.length &&
                  !elements?.components?.length
                    ? false
                    : !isNextEnabled ||
                      (moduleMetadata?.selectedElements?.claims?.length === 0 &&
                        moduleMetadata?.selectedElements?.reusableTexts
                          ?.length === 0))
                }
                isEnabled={
                  !isCurrentModuleSelected
                    ? false
                    : !elements?.claims?.length &&
                        !elements?.reusableTexts?.length &&
                        !elements?.components?.length
                      ? true
                      : isNextEnabled &&
                        // Allow if either claims OR reusable texts are selected
                        (moduleMetadata?.selectedElements?.claims?.length > 0 ||
                          moduleMetadata?.selectedElements?.reusableTexts
                            ?.length > 0)
                }
              >
                {isLoading || buttonLoading || elementsLoading
                  ? "NEXT"
                  : !elements?.claims?.length &&
                      !elements?.reusableTexts?.length &&
                      !elements?.components?.length
                    ? "SKIP MODULE"
                    : "NEXT"}

                {buttonLoading && (
                  <Spinner
                    animation="border"
                    size="sm"
                    variant="primary"
                    text="NEXT"
                    className="ml-1"
                  />
                )}
              </NextButton>
            )}
          </RightButtons>
        </ButtonsSection>

        {/* Cancel Confirmation Modal */}
        <CustomModal
          displayModal={showCancelModal}
          hideModal={cancelModal}
          size="sm"
          dilogClassName="alertModalSmall"
        >
          <ConfirmationPopup
            title="Confirm Cancellation"
            text="Are you sure you want to cancel? All your selections will be lost."
            closeModal={cancelModal}
            handleConfirm={confirmCancel}
            primaryButtonTitle="Cancel"
          />
        </CustomModal>
        {/* Missing Metadata Validation Popup */}
        <CustomModal
          displayModal={showMissingMetadataPopup}
          hideModal={() => setShowMissingMetadataPopup(false)}
          size="sm"
          dilogClassName="alertModalSmall"
        >
          <ConfirmationPopup
            title="Metadata Required"
            text={`Metadata missing for ${missingMetadataModules.join(
              ", ",
            )}. Please provide the relevant information.`}
            isCancelNeeded={false}
            handleConfirm={() => {
              setShowMissingMetadataPopup(false);

              // Navigate to first invalid module
              if (missingMetadataModules.length > 0) {
                const firstModule = missingMetadataModules[0];
                // Extract module number from name (e.g., "Module_1" -> 1)
                const match = firstModule.match(/Module[_\s]?(\d+)/i);
                if (match && match[1]) {
                  const moduleNumber = parseInt(match[1]);
                  if (
                    !isNaN(moduleNumber) &&
                    moduleNumber >= 1 &&
                    moduleNumber <= totalModules
                  ) {
                    // Call parent to navigate to this module
                    onModuleNavigate(moduleNumber);
                  }
                }
              }
            }}
            primaryButtonTitle="OK, GOT IT"
          />
        </CustomModal>
      </ModalContainer>
    </ModalOverlay>
  );
};

// Styled Components
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background: rgba(30, 30, 30, 0.3);
  backdrop-filter: blur(1px);
`;

const ModalContainer = styled.div`
  background-color: #f8f9fa;
  width: 92%;

  width: 1087px;
  border-radius: 6px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  /* Gradient border-top */
  /* Gradient top border */
  border-top: 0 solid transparent;
  background-image:
    linear-gradient(90deg, #203662 50%, #c50f3c 0),
    linear-gradient(#f8f9fa, #f8f9fa);
  background-position: top;
  background-size:
    100% 2px,
    auto; /* 2px height for the gradient, auto for the rest */
  background-repeat: no-repeat;

  @media (max-width: 768px) {
    width: 95%;
    height: 95%;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 20px;
  background: none;
  border: none;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  z-index: 20;
`;

const ModuleContent = styled.div`
  // flex: 1;
  // position: relative;
  // background-color: #ffffff;
  // overflow-y: auto;
  // height: auto;

  flex: 1; /* optional if inside flex parent */
  position: relative;
  background-color: #ffffff;
  // overflow-y: auto; /* enable vertical scroll */

  scrollbar-width: thin; /* optional for Firefox */
  -ms-overflow-style: auto;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    padding: 15px 20px;
    overflow-y: auto;
  }
`;

const BulbIconWrapper = styled.div`
  position: absolute;
  top: 5px;
  right: 20px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 10;
  img {
    width: 24px;
    height: 24px;
  }
`;

const MetadataSection = styled.div`
  max-width: 100%;
  background-color: #fff;
  // // padding: 20px 0;
  // border-radius: 8px;
  // margin-top: 30px;
  // // margin-bottom: 20px;
  // padding: 0px 20px;
  // // height: 37rem;
  height: auto;
  @media (width: 1710px) and (height: 981px),
    (min-width: 1709px) and (max-width: 1711px) and (min-height: 980px) and (max-height: 982px) {
    height: auto;
  }
`;

const MetadataRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  gap: 16px;
  box-sizing: border-box;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const MetadataItem = styled.div`
  flex: ${(props) => (props.fullWidth ? "1 0 100%" : "1")};
  min-width: ${(props) => (props.fullWidth ? "100%" : "0")};

  @media (max-width: 992px) {
    min-width: ${(props) => (props.fullWidth ? "100%" : "220px")};
  }
`;

const ElementsSection = styled.div`
  background-color: #ffffff;
  border-radius: 8px;

  height: auto;
  padding-bottom: 20px;
`;

const ElementPreviewBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ElementsErrorMessage = styled.div`
  color: #ff3b30;
  background-color: rgba(255, 59, 48, 0.1);
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
`;

// Button Section Styles
const ButtonsSection = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 20px;
  background-color: white;
  border-top: 1px solid #eaeaea;
  z-index: 3;
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
  position: sticky;
`;

const RightButtons = styled.div`
  display: flex;
  gap: 16px;
`;

const Button = styled.button`
  padding: 8px 20px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 13px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;
  opacity: ${(props) => (props.disabled ? "0.6" : "1")};
`;

const BackButton = styled(Button)`
  background-color: transparent;
  color: #203662;
  border: 0px;
  border-radius: 20px;
  &:hover {
    // background-color: ${(props) =>
      props.disabled ? "transparent" : "#f5f5f7"};
    background-color: "transparent";
  }
  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
    background-color: transparent;
  }
`;

const CancelButton = styled(Button)`
  background-color: transparent;
  color: #203662;
  border: 0px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 12px;
  &:hover {
    // background-color: ${(props) =>
      props.disabled ? "transparent" : "#f5f5f7"};
    background-color: "transparent";
  }
`;

const NextButton = styled(Button)`
  background-color: ${(props) =>
    props.isEnabled && !props.disabled ? "#203662" : "#D1D1D6"};
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  pointer-events: ${(props) =>
    props.isEnabled && !props.disabled ? "auto" : "none"};
  &:hover {
    background-color: ${(props) =>
      props.isEnabled && !props.disabled ? "#14274B" : "#D1D1D6"};
  }
`;

// Cancel Confirmation Modal Styles
const ConfirmModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
`;

const ConfirmModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  width: 400px;
  padding: 24px;
`;

const ModalTitle = styled.h3`
  margin-top: 0;
  margin-bottom: 16px;
`;

const ModalBody = styled.p`
  margin-bottom: 24px;
`;

const ModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;

const ModalButton = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
`;

const ModalCancelButton = styled(ModalButton)`
  background-color: transparent;
  color: #203662;
  border: 1px solid #203662;
`;

const ModalConfirmButton = styled(ModalButton)`
  background-color: #203662;
  color: white;
  border: none;
`;

const InfoBanner = styled.div`
  display: flex;
  align-items: flex-start;
  background-color: rgba(32, 54, 98, 0.1);
  border-left: 4px solid #203662;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 20px;
`;

const InfoIcon = styled.div`
  margin-right: 12px;
  margin-top: 2px;
`;

const InfoText = styled.div`
  strong {
    display: block;
    margin-bottom: 4px;
    color: #203662;
    font-size: 14px;
  }

  p {
    margin: 0;
    color: #54565b;
    font-size: 13px;
  }
`;

//new tooltip
const CustomTooltip = styled.div`
  position: fixed;
  top: ${(props) => props.top}px;
  right: ${(props) => props.right}px;
  background-color: #fff;
  color: #333;
  font-size: 12px;
  padding: 12px;
  border-radius: 4px;
  white-space: normal;
  word-wrap: break-word;
  font-weight: 600;
  box-shadow: 0px 0px 8px 0px #00000029;
  z-index: 9999;
  width: 220px;
  max-height: 300px;
  overflow-y: auto;
  overscroll-behavior: contain;
  transform: none !important;
  scrollbar-width: thin;
  scrollbar-color: #d1d1d6 #f8f9fa;
  @media (width: 1710px) and (height: 981px),
    (min-width: 1709px) and (max-width: 1711px) and (min-height: 980px) and (max-height: 982px) {
    top: 140px;
    right: 236px;
  }
  /* Triangle arrow on top */
  &::before {
    content: "";
    position: absolute;
    top: -8px;
    right: 20px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #fff;
  }

  /* Better scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f8f9fa;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d1d1d6;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const TooltipHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 2px;

  strong {
    font-size: 12px;
    font-weight: 700;
    color: #1d1d1f;
  }
`;

const TooltipContent = styled.div`
  border-radius: 6px;
  word-wrap: break-word;

  span {
    margin: 0;
    font-size: 12px;
    color: #333;
  }
`;

const TriangleArrow = styled.div`
  position: fixed;
  top: ${(props) => props.top}px;
  right: ${(props) => props.right}px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
  z-index: 10003;
  @media (width: 1710px) and (height: 981px),
    (min-width: 1709px) and (max-width: 1711px) and (min-height: 980px) and (max-height: 982px) {
    top: 133px;
    right: 337px;
  }
`;
